import { RESEARCH_ONLY_LOCATION } from '@/constants';
import { REPLACEMENT_MAPPINGS } from '@/constants/replacementMappings';

export const isResearchOnlyLocation = (locationId: string) => locationId === RESEARCH_ONLY_LOCATION;
export const isAustraliaLocation = (locationId: string) => locationId.startsWith('aus-');

export const replaceLocationBasedTerms = (content: string, locationId: string) => {

  if (typeof content !== 'string' || !locationId) return content;

  let locationSpecificMappings = {};
  if (isAustraliaLocation(locationId)) {
    locationSpecificMappings = REPLACEMENT_MAPPINGS.australia;
  } else if (isResearchOnlyLocation(locationId)) {
    locationSpecificMappings = REPLACEMENT_MAPPINGS.researchOnly;
  }

  const replacements: Record<string, string> = { ...REPLACEMENT_MAPPINGS.default, ...locationSpecificMappings };

  let updatedContent = content;

  Object.keys(replacements).forEach((key) => {
    const replacement = replacements[key];
    updatedContent = updatedContent.replace(new RegExp(`\\b${key}\\b`, 'ig'), (match) => {
      // Match case-sensitive replacement
      if (match === match.toLowerCase()) return replacement.toLowerCase();
      if (match === match.toUpperCase()) return replacement.toUpperCase();
      if (match[0] === match[0].toUpperCase())
        return replacement.charAt(0).toUpperCase() + replacement.slice(1);
      return replacement;
    });
  });

  return updatedContent;
};
